import React, { Component } from 'react';
import './index.css';

// 导出该组件供给其它模块使用
export default class App extends Component {
  render() {
    return <h1 className="app">Hello,Webpack</h1>
  }
}